import Constants from "../constants/Constansts";
import ErrorMessage from "../constants/ErrorMessage";
import { ChatMode } from "../enums/ChatMode";
import { MessageType } from "../enums/MessageType";
import { MessageSender } from "../enums/Sender";
import { Content } from "../models/Content";
import IMessage from "../models/IMessage";
import { IResponse } from "../models/IResponse";
import PostQueryRequest from "../models/PostQueryRequest";
import { QueryResponse } from "../models/QueryResponse";
import { MessageData } from "./MessageData";

export default class MessageDataMapper {
    // Mapper functions
    static mapToMessageDataFromPostQueryRequest(request: PostQueryRequest, userDisplayName: string): MessageData {

        const message: IMessage = {
            parent_message_id: request.parent_message_id,
            message_id: request.message_id,
            conversation_id: request.conversation_id,
            content: request.query,
            author: userDisplayName,
            isUser: true,
            showDate: true,
            datetime: new Date().toISOString(),
            citations: [],
            messageType: MessageType.Regular,
            timestamp: request.created.toISOString(),
            timezone: request.timezone,
            timezone_offset: request.timezone_offset,
            chat_mode: request.chat_mode,
        };
        return {
            message: message,
            isUser: true
        };

    }

    static mapToMessageDataFromQueryResponse(response: IResponse, chat_mode: ChatMode): MessageData {

        const content = response.content

        const message: IMessage = {
            parent_message_id: "",
            message_id: response.message_id,
            conversation_id: response.conversation_id,
            content: typeof content === 'string' ? content : content.Answer,
            author: "wtw ai",
            isUser: false,
            showDate: true,
            datetime: new Date().toISOString(),
            citations: typeof content === 'string' ? [] : content.Citations,
            messageType: MessageType.Regular,
            timestamp: new Date().toISOString(),
            timezone: Constants.TIMEZONE,
            timezone_offset: Constants.TIMEZONE_OFFSET,
            chat_mode: chat_mode
        };
        return {
            message: message,
            isUser: false
        };
    }


    static mapToMessageDataFromError(error: Error, chat_mode: ChatMode): MessageData {
        const message: IMessage = {
            parent_message_id: "Error",
            message_id: "",
            conversation_id: "",
            content: ErrorMessage.PostQueryError,
            author: "wtw ai",
            isUser: false,
            showDate: true,
            datetime: new Date().toISOString(),
            messageType: MessageType.Error,
            timestamp: new Date().toISOString(),
            timezone: Constants.TIMEZONE,
            timezone_offset: Constants.TIMEZONE_OFFSET,
            chat_mode: chat_mode,
        };
        return {
            message: message,
            isUser: false
        };
    }

    static mapToMessageDataFromHistoryQueryResponse(responses: QueryResponse, chat_mode: ChatMode, userDisplayName: string): MessageData[] {
       return responses.contents.map((response:Content) => {
            const content = response.content
            const isUser = response.sender === MessageSender.User;

            const message: IMessage = {
                parent_message_id: response.parent_message_id,
                message_id: response.id,
                conversation_id: responses.conversation_id,
                content: typeof content === 'string' ? content : content.Answer,
                author: isUser ? userDisplayName : "wtw ai",
                isUser: isUser,
                showDate: true,
                datetime: new Date().toISOString(),
                citations: typeof content === 'string' ? [] : content.Citations,
                messageType: MessageType.Regular,
                timestamp: new Date().toISOString(),
                timezone: Constants.TIMEZONE,
                timezone_offset: Constants.TIMEZONE_OFFSET,
                chat_mode: chat_mode
            };
            return {
                message: message,
                isUser: isUser,
            };

        });
    }
}

